export default __webpack_public_path__ + "static/media/react-bootstrap.534ba574.svg";